<template>
    <div class="box-shadow box-shadow--big">
        <div class="helper__wrapper">
            <h5 class="mb-3">{{ $t('TYPE_OF_IMPLANT') }}</h5>

            <div class="flex-row flex-center">
                <label class="fake-label">
                    <input
                        class="custom-input"
                        type="radio"
                        value="SILICON"
                        @change="updateTypeLocation()"
                        name="type-of-implant"
                        v-model="s3q10_type"
                    />
                    <span class="input-container">{{ $t('SILICON') }}</span>
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label">
                    <input
                        class="custom-input"
                        type="radio"
                        value="SALINE"
                        @change="updateTypeLocation()"
                        name="type-of-implant"
                        v-model="s3q10_type"
                    />
                    <span class="input-container">{{ $t('SALINE') }}</span>
                    <span class="checkmark"></span>
                </label>
            </div>
            <hr />
            <h5 class="mb-3">{{ $t('LOCATION_OF_IMPLANT') }}</h5>

            <div class="flex-row flex-center">
                <label class="fake-label">
                    <input
                        class="custom-input"
                        type="radio"
                        value="GLAND"
                        @change="updateTypeLocation()"
                        name="location-of-implant"
                        v-model="s3q10_location"
                    />
                    <span class="input-container">{{ $t('GLAND') }}</span>
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label">
                    <input
                        class="custom-input"
                        type="radio"
                        value="MUSCLE"
                        @change="updateTypeLocation()"
                        name="location-of-implant"
                        v-model="s3q10_location"
                    />
                    <span class="input-container">{{ $t('MUSCLE') }}</span>
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.s3q10_type = this.$store.getters.survey.section3.q10_type;
        this.s3q10_location = this.$store.getters.survey.section3.q10_location;
    },
    data() {
        return {
            s3q10_type: this.q10_type,
            s3q10_location: this.q10_location,
        };
    },
    computed: {
        q10_type() {
            return this.$store.getters.survey.section3.q10_type;
        },
        q10_location() {
            return this.$store.getters.survey.section3.q10_location;
        },
    },
    methods: {
        updateTypeLocation() {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    q10_type: this.s3q10_type,
                    q10_location: this.s3q10_location,
                },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// breast-implants.vue?1f21a0ca